module.exports = __webpack_public_path__ + "static/media/how-it-works-1.8d17dd7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/how-it-works-1.png
// module id = 973
// module chunks = 0